import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementOsGetCpuUsageRequest,
	ManagementOsGetCpuUsageResult,
	ManagementOsGetInfoRequest,
	ManagementOsGetInfoResult,
	ManagementOsGetMemoryUsageRequest,
	ManagementOsGetMemoryUsageResult,
	ManagementOsRequests,
} from './osCommands';

export function handleManagementOsRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementOsRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementOsRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementOsGetInfoRequest:
				await dispatch<ManagementOsGetInfoResult>({
					type: ManagementOsGetInfoResult,
					result: await frontApplet.management.os.getInfo(),
				});
				break;
			case ManagementOsGetCpuUsageRequest:
				await dispatch<ManagementOsGetCpuUsageResult>({
					type: ManagementOsGetCpuUsageResult,
					result: await frontApplet.management.os.getCpuUsage(),
				});
				break;
			case ManagementOsGetMemoryUsageRequest:
				await dispatch<ManagementOsGetMemoryUsageResult>({
					type: ManagementOsGetMemoryUsageResult,
					result: await frontApplet.management.os.getMemoryUsage(),
				});
				break;
			default:
		}
	});
}
